export default {
  general: {
    name: "Flow Simulation Game",
    yes: "Yes",
    no: "No",
    week: "Week",
    add: "Add",
    update: "Update",
    close: "Close",
    cancel: "Cancel",
    search: "Search",
    actions: "Actions",
    language: "Language",
    smallWeek: "W"
  },
  menu : {
    home : 'Home',
    games : 'Games',
    gameVersions : "Game versions",
    demandProfiles : "Demand profiles",
    instructions : "Instructions",
    users: "Users",
    params : "Tokens",
    logout : "Logout",
    profile: "My account"
  },
  fields: {
    required: "Required"
  },
  tokens: {
    token: "Token | Tokens",
    balance: "Your Balance is currently {nbr} token | Your Balance is currently {nbr} tokens",
    title: "Tokens",
    date: "Date",
    orders: "Token order history",
    number: "Number of tokens",
    cost: "Cost",
    bill: "Bill",
    status: "Status"
  },
  users: {
    firstname: "Firstname",
    lastname: "Lastname",
    login: "Login",
    role: "Role",
    password: "Password",
    lang: "Language",
    passwordRule: "8 characters min",
    passwordConfirmation: "The password should be the same",
    confirmation: "Confirmation",
    listTitle: "Users",
    addTitle: "Add user",
    updateTitle: "Update user",
    deleteConfirmation: "Are you sure you want to delete {count} user ? | Are you sure you want to delete {count} users ?"
  },
  roles: {
    trainner: "Trainer",
    admin: "Admin",
    superAdmin: "Super Admin"
  },
  demandProfiles: {
    name: "Name",
    type: "Profile type",
    min: "Min",
    max: "Max",
    constant: "Constant value",
    variability: "Variability",
    confirmation: "Confirmation",
    customDemandsTitle: "Custom demand profile",
    importDemandsButton: "Upload demands",
    importDemandsTemplateButton: "Download Excel template",
    weekNumber: "Week N°",
    demands: "Demand Qty",
    listTitle: "Demand profiles",
    addTitle: "Add demand profiles",
    updateTitle: "Update demand profiles",
    deleteConfirmation: "Are you sure you want to delete {count} demands profile ? | Are you sure you want to delete {count} demand profiles ?",
    typeList: {
      custom: "Custom",
      randomBetweenTwoValue: "Random between two value",
      constant: "Constant value"
    },
    variabilityHint: "In % (ex: 20% demands of 10 value between 8 et 12)"
  },
  instructions: {
    name: "Name",
    addInstruction: "Add instruction(s)",
    listTitle: "Instructions lists",
    addTitle: "Add instruction list",
    updateTitle: "Update instruction list",
    deleteConfirmation: "Are you sure you want to delete {count} instruction list ? | Are you sure you want to delete {count} instruction lists ?"
  },
  gameVersions: {
    type: "Type",
    dd: "DD",
    standard: "Standard",
    updateLogo: "update logo",
    menu: "Menu",
    params: "Params",
    style: "Styles",
    name: "Name",
    colors: {
      primary: "Primary color",
      secondary: "Secondary color"
    },
    maxOrder: "Maximum supplier order",
    skipInstructions: "Skip the instructions",
    timerActivated: "Activate a daily timer",
    timerCount: "Duration of the timer",
    timerCountHint: "In secondes per step",
    storageCost: "Inventory cost",
    delayCost: "Shortaged cost",
    weekNbrAutoCmj: "Week nbr for auto ADU calculation",
    changeBufferEveryNbrWeek: "The buffer can be changed every x week",
    versionToDuplicate: "Game version to duplicate",
    listTitle: "Game versions",
    addTitle: "Add game version",
    addNew: "New version",
    addFromVersion: "From an existing version",
    updateTitle: "Update game version",
    deleteConfirmation: "Are you sure you want to delete {count} game version ? | Are you sure you want to delete {count} game versions ?",
    flowEquationDisplayModes: {
      title: "Net Flow Equation display mode",
      notDisplay: "Net Flow Equation is not displayed",
      alreadyCalculated: "Net Flow Equation is displayed pre filled",
      show: "Net Flow Equation must be filled"
    },
    ddOrderPreFilled: "Pre-fill the quantity to order in DD mode"
  },
  games: {
    test: "Test mode",
    favorites: "Favorite",
    name: "Name",
    code: "Code",
    version: "Version",
    createdBy: "Created by",
    createdAt: "Creation Date",
    status: "Status",
    listTitle: "Games",
    addTitle: "Create a new game",
    deleteConfirmation: "Are you sure you want to delete {count} game ? | Are you sure you want to delete {count} games ?",
    statusList: {
      created: "Created",
      open: "Open",
      inProgress: "In progress",
      finished: "Finished"
    },
    pause: "The game has been paused",
    play: "The game is restarted",
    stop: "You ended the game",
    start: "The game is restarted",
    debriefOn: "You have given access to debriefing",
    debriefOff: "You have canceled access to the debriefing"
  },
  inGame: {
    delete: "Delete the game and get my tokens back",
    deleteConfirmation: "Are you sure you want to permanently delete the game ?",
    setPause: "Pause",
    setPlay: "Play",
    endGame: "End the game",
    reopenGame: "Restarts the game",
    debriefOn: "Give access to debriefing",
    debriefOff: "Hide debriefing",
    companies: {
      playerName: "Player",
      companies: "Companies",
      step: "Step",
      assigned: "Connected",
      ready: "Ready",
      code: "Code",
      steps: {
        clientOrder: "Sales Orders",
        clientShipment: "Customer Shipments",
        supplierShimpentWaiting: "Waiting for deliveries",
        board: "Dashboard",
        supplierShipments: "Supplier Deliveries",
        supplierOrders: "Supplier Orders",
        productionBatch: "Production Start",
        productionShipments: "Production Deliveries",
        startNewWeek: "Start a new week",
        inProgressProduction: "Work In Process",
      }
    },
    resume: {
      resume: "Summary",
      averageOrderQuantity: "Average demand send to the supplier",
      averageRequestQuantity: "Average customer demand",
      range: "Demand range",
      otd: "On Time Delivery",
      delaysDepth: "Delays in weeks",
      averageStock: "Average on-hand inventory",
      stockCost: "Inventory Cost",
      delayCost: "Shortages Cost",
      cost: "Total Cost",
    },
    red: "Red Zone",
    yellow: "Yellow Zone",
    green: "Green Zone",
    flowEquation: "Net Flow",
    stock: "Inventory",
    buffers: "Buffers",
    orders: "Orders",
    costs: "Costs",
    stockRemains: "Inventory & shortages",
    shortage: "Shortage",
    supplychainGraph: "Supply Chain",
    repport: "PDF Report"
  },
  companiesSettings: {
    supplyPicture: "Map of the Supply Chain",
    logo: "Logo",
    name: "Name",
    level: "Level",
    suppliers: "Supplier(s)",
    clients: "Client(s)",
    leadTime: "Shipping leadtime",
    productionLeadTime: "Production leadtime",
    initialStock: "Initial inventory",
    firstOrder: "Initial order",
    firstProduction: "Initial production",
    ddOn: "DD mode activated",
    simulatedCompany: "Simulated by the system",
    productionCompany: "Factory",
    assemblyMode: "Assembly mode",
    demandProfile: "Demands profile",
    confirmation: "Confirmation",
    listTitle: "Companies",
    addTitle: "Add company",
    updateTitle: "Update company",
    deleteConfirmation: "Are you sure you want to delete {count} company ? | Are you sure you want to delete {count} companies ?",
    updateLogo: "Update logo",
    updateSupplyPicture: "Update the supply chain map"
  },
  notifications: {
    users: {
      welcome : "Welcome ",
      sessionExpired : "Your session has expired, please log in again",
      getOneError: "Error while loading user : ",
      getAllError: "Error while loading users : ",
      add: "The user has been added",
      addError: "Error while creating user : ",
      update: "The user has been modified",
      updateError: "Error while updating user : ",
      delete: "The deletion has been done",
      deleteError: "Error while deleting users : "
    },
    demandProfiles: {
      getOneError: "Error while loading the demand profile : ",
      getAllError: "Error while loading the demand profiles : ",
      add: "The demand profile has been added",
      addError: "Error while creating the demand profile : ",
      update: "The demand profile has been modified",
      updateError: "Error while updating the demand profile : ",
      delete: "The deletion has been done",
      deleteError: "Error while deleting the demand profile : "
    },
    gameVersions: {
      getOneError: "Error while loading the game version : ",
      getAllError: "Error while loading games versions : ",
      add: "The game versions have been added",
      addError: "Error while creating the game version : ",
      update: "The game version has been modified",
      updateError: "Error while updating the game version : ",
      delete: "The deletion has been done",
      deleteError: "Error while deleting game versions : "
    },
    companiesSettings: {
      getOneError: "Error while loading the node : ",
      getAllError: "Error while loading nodes : ",
      add: "The node has been added",
      addError: "Error while creating the node : ",
      update: "The node has been modified",
      updateError: "Error while updating the node : ",
      delete: "The deletion has been done",
      deleteError: "Error while deleting nodes : "
    },
    games: {
      getOneError: "Error while loading the game : ",
      getAllError: "Error while loading games : ",
      add: "The game has been added",
      addError: "Error while creating the game : ",
      update: "The game has been modified",
      updateDemands: "The demand profile has been modified",
      updateDemandsError: "Error while updating the demand profile : ",
      updateError: "Error while updating the game : ",
      delete: "The deletion has been done",
      deleteError: "Error while deleting the game : "
    }
  },
  socketMessages: {
    playerReady : "The following node is ready : ",
    stepChange : "The following node goes to next step : ",
    connexion : "Connecting the node : ",
    clientsShipments : "The following node delivers its clients : ",
    suppliersOrders : "The following node placed orders : ",
    productionBatch: "The following node started a production : ",
    customerUpdate: "Updating the node : "
  }
}